/** Режим передачи тенанта в App API (FRONTEND_GUIDE §3) */
export type AuthMode = 'header' | 'oidc';

function readAuthMode(): AuthMode {
  const raw = import.meta.env.VITE_AUTH_MODE as string | undefined;
  return raw === 'oidc' ? 'oidc' : 'header';
}

function readApiBaseUrl(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined) ?? '';
  return raw.endsWith('/') ? raw.slice(0, -1) : raw;
}

/** Рантайм-окружение core. Значения — из import.meta.env (Vite). */
export const coreEnv = {
  /**
   * Базовый URL App API (FRONTEND_GUIDE §2): без префикса /api, например
   * http://192.168.1.94:8003. Пусто — тот же origin.
   */
  apiBaseUrl: readApiBaseUrl(),
  /** 1 (по умолчанию) — всё на моках; 0 — App API по-настоящему (см. client.ts) */
  mockEnabled: import.meta.env.VITE_API_MOCK !== '0',
  /**
   * header — локальный режим бэка (auth: "disabled"), шлём X-Tenant-Id;
   * oidc — Keycloak, шлём Authorization: Bearer <access_token>.
   */
  authMode: readAuthMode(),
  tenantOverride: import.meta.env.VITE_TENANT_OVERRIDE as string | undefined,
  /**
   * Keycloak для authMode=oidc (FRONTEND_GUIDE §3.1). oidcUrl — БАЗОВЫЙ URL,
   * КАК ЕГО ВИДИТ БРАУЗЕР (совпадает с хостом issuer'а в APP_OIDC_ISSUER бэка),
   * например http://192.168.1.94:8080.
   */
  oidcUrl: (import.meta.env.VITE_OIDC_URL as string | undefined) ?? '',
  oidcRealm: (import.meta.env.VITE_OIDC_REALM as string | undefined) ?? 'buildex',
  oidcClientId: (import.meta.env.VITE_OIDC_CLIENT_ID as string | undefined) ?? 'app-api',
} as const;
